import React, { Component } from 'react';
import ImageCutoutWork from './children/ImageCutoutWork';

import '@/assets/imageCutout.less';

class ImageCutout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
    };
  }

  render() {
    return (
      <div className='ImageCutout'>
        <ImageCutoutWork pageType={this.props.pageType} />
      </div>
    );
  }
}

export default ImageCutout;
